export default __webpack_public_path__ + "static/media/aws-logo.876f44e4.jpg";